import { Logs } from 'models/logs';
import { apiUrl, get } from 'utils/apiMgmt';

export const getLogs = async (): Promise<Logs[]> => {
  const { data } = await get(apiUrl + '/logs');
  return data;
};
